import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import AnimateHeight from 'react-animate-height';
import { withRtl } from '../hoc';
import style from './SchoolProgram.scss';
import SchoolProgramInfo from '../SchoolProgramInfo';
import SchoolProgramInfoK from '../SchoolProgramInfoK';
import SchoolProgramInfoSR from '../SchoolProgramInfoSR';
import Button from '../Button';
import ButtonAction from '../ButtonAction';
import Lightbox from '../Lightbox';
import {
  applySchedulingOk,
  programHasAppointment,
  detectActivationEvent,
  programHasExpressionOfInterest,
  isMS,
  isHS,
  isK,
  isPK,
  is2K,
  is3K,
  isSR,
  isEL,
  isGTAPP,
  processNameToShortCode,
  isWaitlist,
  customisedIntlFormatMessage,
  hideGuaranteedOfferExcludedSchools,
} from '../../utils/helpers';
import Tooltip from '../Tooltip';
import ApplicantsPerSeatPillBox from '../ApplicantsPerSeatPillBox';
import InfoIcon from '../icons/Info';
import MultiColoredStarIcon from '../icons/MultiColoredStar';
import NonElligibleIcon from '../icons/NonElligible';
import ZoneIcon from '../icons/Zone';
import CardCurrentSchoolIcon from '../icons/CardCurrentSchool';
import AlreadyAppliedIcon from '../icons/AlreadyApplied';
import JoinedWaitlistIcon from '../icons/JoinedWaitlistIcon';
import { saveProgram } from '../../actions/saveProgram';
import { saveApplication } from '../../actions/saveApplication';
import { showPopupContent } from '../../actions/popup';
import { joinWaitlist, removeFromWaitlist, removeFromWaitlistSchoolDirectory } from '../../actions/joinWaitlist';
import messages from '../../locale/messages';
import ScheduleInfo from '../../routes/schedule/ScheduleInfo';
import LooIcon from '../icons/LooIcon';
import analytics from '../../services/analytics';

const localMessages = defineMessages({
  schoolProgramLikelihoodToolTipApplicants: {
    id: 'schoolProgram.ToolTipApplicants',
    defaultMessage: `{number} applicants per seat last year`,
    description: 'number of applicants per seat last year',
  },
  schoolProgramAddedToApplicationPopup: {
    id: 'schoolProgram.AddedToApplicationPopup',
    defaultMessage: 'This program has been added to your application',
    description: 'Popup content when a program is added to the application.',
  },
  schoolProgramRemovedFromApplicationPopup: {
    id: 'schoolProgram.RemovedFromApplicationPopup',
    defaultMessage: 'This program has been removed from your application',
    description: 'Popup content when a program is removed from the application.',
  },
  schoolProgramSavedPopup: {
    id: 'schoolProgram.SavedPopup',
    defaultMessage: 'This program has been favorited.',
    description: 'Popup content when a program is saved.',
  },
  schoolProgramIsAddedToApplicationTitle: {
    id: 'schoolProgram.AddedToApplicationTitle',
    defaultMessage: 'IN APPLICATION',
    description: 'Program was added to application and can not be unsaved.',
  },
  schoolProgramIsAddedToApplication: {
    id: 'schoolProgram.AddedToApplication',
    defaultMessage: 'To unsave this program, first remove it from your application.',
    description: 'Program was added to application and can not be unsaved.',
  },
  schoolProgramHasScheduledAppointmentTitle: {
    id: 'schoolProgram.schoolProgramHasScheduledAppointmentTitle',
    defaultMessage: 'SCHEDULED',
    description: 'Program was added to application and can not be unsaved.',
  },
  schoolProgramHasScheduledAppointment: {
    id: 'schoolProgram.ScheduledAppointment',
    defaultMessage: 'To unsave this program, first cancel your scheduled appointment.',
    description: 'Program has a scheduled appointment and can not be unsaved',
  },
  schoolProgramSaveWithProgramSchoolDescription: {
    id: 'schoolProgram.SaveWithProgramSchoolDescription',
    defaultMessage: 'Save program: {programTitle}, for school: {schoolName}',
    description: 'Save program message',
  },
  schoolProgramUnsaveWithProgramSchoolDescription: {
    id: 'schoolProgram.UnsaveWithProgramSchoolDescription',
    defaultMessage: 'Unsave program: {programTitle}, for school: {schoolName}',
    description: 'Unsave program message',
  },
  schoolProgramSaveLoggedInUserTitle: {
    id: 'schoolProgram.saveLoggedInUserTitle',
    defaultMessage: `Select a child's application to add to your favorites`,
    description:
      'String title used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramSaveLoggedInUserDescription: {
    id: 'schoolProgram.saveLoggedInUserDescription',
    defaultMessage: `You can favorite programs by going to the dashboard and clicking "Get Started" or "Continue" or "Submitted".`,
    description:
      'String description used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramSaveLoggedInUserWaitlistNoResultDescription: {
    id: 'schoolProgram.saveLoggedInUserWaitlistNoResultDescription',
    defaultMessage: `You can favorite programs by going to the dashboard and clicking "Search & Join Waitlists".`,
    description:
      'String description used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramSaveLoggedInUserWaitlistResultDescription: {
    id: 'schoolProgram.saveLoggedInUserWaitlistResultDescription',
    defaultMessage: `You can favorite programs by going to the dashboard and clicking "View Results & Waitlists".`,
    description:
      'String description used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramSaveLoggedInUserClosedProgramDescription: {
    id: 'schoolProgram.saveLoggedInUserClosedProgramDescription',
    defaultMessage: `You can favorite programs when the application is open.`,
    description:
      'String description used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramSaveUnloggedInUserTitle: {
    id: 'schoolProgram.saveUnloggedInUserTitle',
    defaultMessage: 'Sign up to add programs to your favorites',
    description:
      'String title used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramSaveUnloggedInUserDescription: {
    id: 'schoolProgram.saveUnloggedInUserDescription',
    defaultMessage: 'You can favorite programs when the application is open and you are logged into your account.',
    description:
      'String description used to inform user to select a child application when saving a program in global directory',
  },
  schoolProgramAddedToYourApplication: {
    id: 'schoolProgram.AddedToYourApplication',
    defaultMessage: 'Added to your application',
    description: 'String description if program was already added to the application',
  },
  schoolProgramLoggedInModalTitle: {
    id: 'schoolProgram.LoggedInModalTitle',
    defaultMessage: `Select a child's application`,
    description: 'String representing logged in modal when saving a program in global directory',
  },
  schoolProgramCurrentSchoolProgramK: {
    id: 'schoolProgram.CurrentSchoolProgramK',
    defaultMessage: `This is your child’s current school. Your child will receive priority to this program as a current student.`,
    description: 'Kindergarten current school program tooltip',
  },
  schoolProgramCurrentSchoolProgramMessageFirstParagraph: {
    id: 'schoolProgram.CurrentSchoolProgramMessageFirstParagraph',
    defaultMessage: `By applying to this program, {firstName} will be guaranteed a seat, because this school guarantees offers to current students.`,
    description:
      'String description to tell student they are guaranteed an offer by applying to this program, first paragraph',
    values: {
      firstName: 'your child',
    },
  },
  schoolProgramCurrentSchoolProgramMessageSecondParagraph: {
    id: 'schoolProgram.CurrentSchoolProgramMessageSecondParagraph',
    defaultMessage: `Put it below other programs on your application list -- otherwise {firstName} will match to this program and not be considered for ones listed below it.`,
    description:
      'String description to tell student they are guaranteed an offer by applying to this program, second paragraph',
    values: {
      firstName: 'your child',
    },
  },
  schoolProgramKindergartenEligibleTooltipBody: {
    id: 'schoolProgram.KindergartenEligibleTooltipBody',
    defaultMessage:
      'Your chances of an offer are a combination of your priority group for this program and its offers last year. Open the program’s details to review its priority groups.',
    description: 'Kindergarten student eligibility tooltip message',
  },
  schoolProgramConfirmDialogJoinWaitlistText: {
    id: 'schoolProgram.ConfirmDialogJoinWaitlistText',
    defaultMessage:
      'You will be added to this waitlist. You can’t remove your child from a waitlist once you’ve joined.',
    description: 'Join Waitlist Confirmation',
  },
  schoolProgramJoinWaitlistTooltip: {
    id: 'schoolProgram.JoinWaitlistTooltip',
    defaultMessage: 'You can join the waitlist for a program you are eligible for.',
    description: 'Join Waitlist Tooltip',
  },
  schoolProgramOnWaitlistMessage: {
    id: 'schoolProgram.OnWaitlistMessage',
    defaultMessage: 'On Waitlist',
    description: 'Already Joined Waitlist Label',
  },
  schoolProgramOnWaitlistTooltip: {
    id: 'schoolProgram.OnWaitlistTooltip',
    defaultMessage: 'Already On Waitlist',
    description: 'Already Joined Waitlist Tooltip',
  },
  schoolProgramOnSubmittedApplicationMessage: {
    id: 'schoolProgram.OnSubmittedApplicationMessage',
    defaultMessage: 'On Submitted Application',
    description: 'The program has been added to a submitted application and is waiting for results',
  },
  schoolProgramOnSubmittedApplicationTooltip: {
    id: 'schoolProgram.OnSubmittedApplicationTooltip',
    defaultMessage: 'The program has been added to a submitted application and is waiting for results',
    description: 'The program has been added to a submitted application and is waiting for results',
  },
  schoolProgramJoinedWaitlistTitle: {
    id: 'schoolProgram.JoinedWaitlistTitle',
    defaultMessage: 'JOINED WAITLIST',
    description: 'Program was added to application and can not be unsaved.',
  },
  schoolProgramJoinedWaitlist: {
    id: 'schoolProgram.JoinedWaitlist',
    defaultMessage: 'You can’t unsave programs whose waitlist you’re on.',
    description: 'Users can’t unsave programs whose waitlist they’re on',
  },
  schoolProgramJoinedWaitlistPopup: {
    id: 'schoolProgram.JoinedWaitlistPopup',
    defaultMessage: 'You have joined the waitlist for this program.',
    description: 'Popup content when a waitlist is joined for a program.',
  },
  schoolProgramRemovedWaitlistPopup: {
    id: 'schoolProgram.RemovedWaitlistPopup',
    defaultMessage: 'You have been removed from the waitlist for this program.',
    description: 'Popup content when a waitlist is removed for a program.',
  },
});

class SchoolProgram extends Component {
  static propTypes = {
    admissionMethod: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
    applicationId: PropTypes.string,
    applicantsPerSeat: PropTypes.number,
    applyCard: PropTypes.bool.isRequired,
    description: PropTypes.string,
    eligible: PropTypes.bool,
    emphasize: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    getPriorityGroups: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool,
    program: PropTypes.shape({
      is_shs: PropTypes.bool,
      admission_process: PropTypes.string,
      code: PropTypes.string,
    }).isRequired,
    accessibility: PropTypes.string,
    school: PropTypes.shape({
      dbn: PropTypes.string,
      name: PropTypes.string,
    }),
    programClick: PropTypes.func.isRequired,
    programOpen: PropTypes.number,
    schoolId: PropTypes.number.isRequired,
    selected: PropTypes.bool,
    saved: PropTypes.bool,
    saveApplication: PropTypes.func.isRequired,
    saveProgram: PropTypes.func.isRequired,
    savedProgramId: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    savedApplication: PropTypes.bool,
    savedApplicationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    scheduling: PropTypes.arrayOf(PropTypes.shape({})),
    schoolUrl: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    showDetails: PropTypes.bool.isRequired,
    tip: PropTypes.node.isRequired,
    tipIcon: PropTypes.string.isRequired,
    tipLabel: PropTypes.string,
    title: PropTypes.string.isRequired,
    testing_not_registered: PropTypes.bool,
    url: PropTypes.string.isRequired,
    user: PropTypes.shape({
      applicationId: PropTypes.string.isRequired,
      maxPrograms: PropTypes.number.isRequired,
      isSHS: PropTypes.bool.isRequired,
      isRound2: PropTypes.bool.isRequired,
      isMS: PropTypes.bool.isRequired,
      guardianId: PropTypes.string,
      studentApplications: PropTypes.shape({
        loaded: PropTypes.bool,
        results: PropTypes.arrayOf(PropTypes.number),
      }).isRequired,
      studentWaitlists: PropTypes.shape({
        loaded: PropTypes.bool,
        results: PropTypes.arrayOf(PropTypes.number),
      }).isRequired,
      // applicationsLoaded: PropTypes.bool.isRequired,
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    showPopupContent: PropTypes.func.isRequired,
    is_zoned_program: PropTypes.bool,
    directory_school_name: PropTypes.string,
    singleProgramCard: PropTypes.bool,
    scheduleProgram: PropTypes.shape(),
    initScheduling: PropTypes.func,
    removeNoMatchingTimeSlot: PropTypes.func,
    schoolName: PropTypes.string.isRequired,
    admissionsOpen: PropTypes.bool.isRequired,
    waitlistOpen: PropTypes.bool.isRequired,
    resultsEnabled: PropTypes.bool.isRequired,
    is_current_school: PropTypes.bool,
    admissionProcess: PropTypes.string,
    joinedWaitlist: PropTypes.bool.isRequired,
    joinWaitlist: PropTypes.func.isRequired,
    onSubmittedApplication: PropTypes.bool,
    isAffiliatedSRLocation: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    applicationId: '',
    applicantsPerSeat: null,
    description: '',
    scheduling: [],
    eligible: false,
    emphasize: false,
    loggedIn: false,
    onClick: false,
    programOpen: 0,
    selected: false,
    tipLabel: '',
    saved: false,
    savedProgramId: false,
    savedApplication: false,
    savedApplicationId: false,
    firstName: '',
    singleProgramCard: false,
    scheduleProgram: null,
    initScheduling: null,
    removeNoMatchingTimeSlot: null,
    is_zoned_program: false,
    directory_school_name: null,
    admissionProcess: null,
    is_current_school: false,
    testing_not_registered: false,
    admissionsOpen: false,
    waitlistOpen: false,
    resultsEnabled: false,
    isAffiliatedSRLocation: false,
  };

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (nextProps.programOpen !== prevState.programOpen) {
  //     return {
  //       ...prevState,
  //       //programOpen: nextProps.programOpen,
  //       //height: nextProps.programOpen ? 'auto' : 0,
  //     };
  //   }
  //   return null;
  // }

  constructor(props) {
    super(props);

    this.state = {
      programOpen: props.programOpen,
      showModal: false,
      modalContext: null,
      showTooltip: false,
      height: props.programOpen ? 'auto' : 0,
    };

    const parts = window.location.pathname.split('/');
    this.processName = parts.pop() || parts.pop(); // handle potential trailing slash
    this.admissionProcess = processNameToShortCode({ processName: this.processName });
  }

  // eslint-disable-next-line consistent-return
  componentDidUpdate(prevProps) {
    const prevApplications = prevProps.user.studentApplications;
    const currentApplications = this.props.user.studentApplications;

    const prevWaitlists = prevProps.user.studentWaitlists;
    const currentWaitlists = this.props.user.studentWaitlists;

    // user's student applications have been initially loaded
    if (prevApplications.loaded === currentApplications.loaded) {
      // an application was added/removed
      if (currentApplications.results.length > prevApplications.results.length) {
        this.props.showPopupContent({
          children: <FormattedMessage {...localMessages.schoolProgramAddedToApplicationPopup} />,
        });
      } else if (currentApplications.results.length < prevApplications.results.length) {
        this.props.showPopupContent({
          children: <FormattedMessage {...localMessages.schoolProgramRemovedFromApplicationPopup} />,
        });
      }
    }

    // user's student waitlists have been initially loaded
    if (prevWaitlists.loaded === currentWaitlists.loaded) {
      // a waitlist was joined
      if (currentWaitlists.results.length > prevWaitlists.results.length) {
        this.props.showPopupContent({
          children: <FormattedMessage {...localMessages.schoolProgramJoinedWaitlistPopup} />,
        });
        // eslint-disable-next-line react/no-did-update-set-state
        return this.setState({
          ...this.state,
          showTooltip: false,
        });
      } else if (currentWaitlists.results.length < prevWaitlists.results.length) {
        this.props.showPopupContent({
          children: <FormattedMessage {...localMessages.schoolProgramRemovedWaitlistPopup} />,
        });
      }
    }
  }

  getSchoolProgramInfo = () => {
    const { user, admissionProcess } = this.props;
    const isKProcess = isK({ user }) || this.admissionProcess === 'K' || admissionProcess === 'K';
    const isPKProcess = isPK({ user }) || this.admissionProcess === 'PK' || admissionProcess === 'PK';
    const is2KProcess = is2K({ user }) || this.admissionProcess === '2K' || admissionProcess === '2K';
    const is3KProcess = is3K({ user }) || this.admissionProcess === '3K' || admissionProcess === '3K';
    const isSRProcess = isSR({ user }) || this.admissionProcess === 'SR' || admissionProcess === 'SR';
    const isHSProcess = isHS({ user }) || this.admissionProcess === 'HS' || admissionProcess === 'HS';
    const isMSProcess = isMS({ user }) || this.admissionProcess === 'MS' || admissionProcess === 'MS';
    const isGTProcess = isGTAPP({ user }) || this.admissionProcess === 'GTAPP' || admissionProcess === 'GTAPP';
    const showSWDNote = isHSProcess || isMSProcess;
    if (isKProcess || isPKProcess || is2KProcess || is3KProcess || isGTProcess) {
      return <SchoolProgramInfoK {...this.props} showSWDNote={showSWDNote}  />;
    }

    if(isSRProcess){
      return <SchoolProgramInfoSR {...this.props} showSWDNote={showSWDNote}  />;
    }

    return <SchoolProgramInfo {...this.props} showSWDNote={showSWDNote} />;
  };

  saveApplicationFunc = (id, schoolId, savedApplication, savedApplicationId, saved, savedProgramId) => {
    if (!this.props.user.applicationId && this.props.user.applicationId === '') {
      return this.setState({
        ...this.state,
        showModal: true,
        modalContext: 'application',
      });
    }

    // specialized high schools shouldn't be able to handle application
    if (this.props.user.isSHS) {
      return false;
    }

    this.props.saveApplication(id, schoolId, '', savedApplication, savedApplicationId).then((status) => {
      if(status == 'ADD_TO_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(true);
      }
      if(status == 'REMOVE_FROM_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(false);
      }
    });
  
    if (!saved) {
      this.props.saveProgram(id, schoolId, saved, savedProgramId);
      this.props.showPopupContent({
        children: <FormattedMessage {...localMessages.schoolProgramSavedPopup} />,
      });
    }
    return true;
  };

  cannotUnsaveProgram = () => {
    const { savedApplication, scheduling, joinedWaitlist } = this.props;
    const hasAppointment = programHasAppointment(scheduling) || programHasExpressionOfInterest(scheduling);
    return savedApplication || hasAppointment || joinedWaitlist;
  };

  saveProgramFunc = (id, schoolId, saved, savedProgramId) => {
    const { applicationId } = this.props.user;
    if (!applicationId && applicationId === '') {
      return this.setState({
        ...this.state,
        showModal: true,
        modalContext: 'program',
      });
    }

    if (this.cannotUnsaveProgram()) {
      return this.toggleTooltip();
    }

    this.props.saveProgram(id, schoolId, saved, savedProgramId).then((resp) => {
      if(resp == 'FAVORITE_SUCCESS'){
        this.handleLooProgramFavoriteAction(true);
      }
      if(resp == 'UNFAVORITE_SUCCESS'){
        this.handleLooProgramFavoriteAction(false);
      }
    });
    if (!saved) {
      this.props.showPopupContent({
        children: <FormattedMessage {...localMessages.schoolProgramSavedPopup} />,
      });
    }
    return true;
  };

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.close();
    }
  };

  signUp = () => {
    const { intl } = this.props;
    window.location = `/${intl.locale}/account/create-account/`;
  };

  dashboard = () => {
    const { intl } = this.props;
    window.location = `/${intl.locale}/dashboard/`;
  };

  toggleProgram = () => {
    const { programOpen } = this.state;
    this.setState({
      ...this.state,
      programOpen: !programOpen,
      height: !programOpen ? 'auto' : 0,
    });
    this.handleProgramClickAnalytics();
  };

  close = () => {
    this.setState({
      ...this.state,
      showModal: false,
      modalContext: null,
    });
  };

  open = () => {
    this.setState({
      ...this.state,
      showModal: true,
      modalContext: null,
    });
  };

  toggleTooltip = () => {
    const { showTooltip } = this.state;

    this.setState({
      ...this.state,
      showTooltip: !showTooltip,
    });
  };

  handleProgramClickAnalytics = () => {
    const { school, program, loggedIn } = this.props;
    const { code, name } = program;
    const { programOpen } = this.state;
    let dataDictionary = {
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    let event_name = 'schoolClick';
    if(this.props.showDetails || !loggedIn){
      event_name = 'programClick';
    }
    if(!programOpen){
      analytics({
        eventLabel: event_name,
        dataDictionary: dataDictionary,
      });
    }
  };

  handleProgramClick = event => {
    const { programClick, id, schoolId, school } = this.props;
    if (detectActivationEvent(event)) {
      programClick(id, schoolId, school.dbn);
      this.toggleProgram();
    }
  };

  shouldRenderApplication = () => this.props.user && !this.props.user.isSHS;

  currentSchoolTooltipBodyK = () => {
    const { intl, title } = this.props;

    return (
      <div className={style.tip}>
        <Tooltip
          {...this.props}
          icon={<CardCurrentSchoolIcon fill="#024cbc" size="20" />}
          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramCurrentSchoolInfo, {
            programTitle: title,
            schoolName: this.props.directory_school_name,
          })}
        >
          <p>
            <FormattedMessage {...localMessages.schoolProgramCurrentSchoolProgramK} />
          </p>
        </Tooltip>
      </div>
    );
  };

  currentSchoolTooltipBody = () => {
    const { firstName, intl, title } = this.props;
    if (!hideGuaranteedOfferExcludedSchools(this.props.school.dbn)) {
      return (
        <div className={style.tip}>
          <Tooltip
            {...this.props}
            icon={<CardCurrentSchoolIcon fill="#024cbc" size="20" />}
            ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramCurrentSchoolInfo, {
              programTitle: title,
              schoolName: this.props.directory_school_name,
            })}
          >
            <p>
              <FormattedMessage
                {...localMessages.schoolProgramCurrentSchoolProgramMessageFirstParagraph}
                values={{ firstName }}
              />
            </p>

            <p>
              <i>
                <FormattedMessage
                  {...localMessages.schoolProgramCurrentSchoolProgramMessageSecondParagraph}
                  values={{ firstName }}
                />
              </i>
            </p>
          </Tooltip>
        </div>
      );
    }
    return null;
  };

  zonedProgramTooltipBody = () => {
    const { firstName, intl, title, user } = this.props;

    let tooltipMessage = <FormattedMessage {...messages.schoolProgramToolTipZoned} values={{ firstName }} />;
    if (isMS({ user })) {
      tooltipMessage = <FormattedMessage {...messages.schoolProgramToolTipZonedMiddleSchool} values={{ firstName }} />;
    } else if (isK({ user }) || isPK({ user }) || is2K({ user }) || is3K({ user })) {
      tooltipMessage = <FormattedMessage {...messages.schoolProgramToolTipZonedK} />;
    }

    return (
      <div className={style.tip}>
        <div className={style.zoned}>
          <FormattedMessage {...messages.generalStringZoned} />
        </div>
        <Tooltip
          {...this.props}
          icon={<ZoneIcon border="#000" fill="#4EE4B3" size="20" />}
          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramZonedProgramInfo, {
            programTitle: title,
            schoolName: this.props.directory_school_name,
          })}
        >
          <p>{tooltipMessage}</p>
        </Tooltip>
      </div>
    );
  };

  eligibleKindergartenTooltipBody = () => {
    const { intl, title } = this.props;
    return (
      <div className={style.tip} data-coachmark="search-step-7">
        <Tooltip
          {...this.props}
          icon={<InfoIcon border="#000" fill="#4DB6F7" size="20" />}
          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramEligibleInfo, {
            programTitle: title,
            schoolName: this.props.directory_school_name,
          })}
        >
          <div className={style.messaging}>
            <FormattedMessage {...localMessages.schoolProgramKindergartenEligibleTooltipBody} />
          </div>
        </Tooltip>
      </div>
    );
  };

  eligibleTooltipBody = () => {
    const { applicantsPerSeat, intl, title } = this.props;
    return (
      <div className={style.tip} data-coachmark="search-step-7">
        <Tooltip
          {...this.props}
          icon={<InfoIcon border="#000" fill="#4DB6F7" size="20" />}
          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramEligibleInfo, {
            programTitle: title,
            schoolName: this.props.directory_school_name,
          })}
        >
          <h6>
            <FormattedMessage {...messages.schoolProgramToolTipTopTitle} />
          </h6>
          <div className={style.eligibilityTipTopParagraph}>
            <FormattedMessage {...messages.schoolProgramToolTipTopParagraph} values={{strong: (chunks) => <strong>{chunks}</strong> }} />
          </div>
          {applicantsPerSeat > 0 && (
            <div className={style.statsBox}>
              <div className={style.statsBoxTitle}>
                {' '}
                <FormattedMessage {...messages.generalStringApplicantsPerSeat} />
              </div>
              <ApplicantsPerSeatPillBox applicantsPerSeat={applicantsPerSeat} />
              <div className={style.noUnderline}>
                {applicantsPerSeat} <FormattedMessage {...messages.generalStringApplicantsPerSeatLastYear} />
              </div>
            </div>
          )}
          {this.renderPriorityGroup()}
          <div className={style.messaging}>
            <FormattedMessage {...messages.schoolProgramToolTipLikelihoodFirstParagraph} />
          </div>
        </Tooltip>
      </div>
    );
  };

  ineligibleTooltipBody = () => {
    const { firstName, intl, title } = this.props;
    return (
      <div className={style.tip}>
        <Tooltip
          {...this.props}
          icon={<NonElligibleIcon border="#000" fill="#F66563" size="20" />}
          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramNotEligibleInfo, {
            programTitle: title,
            schoolName: this.props.directory_school_name,
          })}
        >
          <p>
            <FormattedMessage {...messages.schoolProgramNotEligibleFirstParagraph} values={{ firstName }} />
          </p>
          <p className={style.italic}>
            <FormattedMessage {...messages.schoolProgramNotEligibleSecondParagraph} />
          </p>
        </Tooltip>
      </div>
    );
  };

  looTooltipContent = () => {
    const { loo_chances, admissions_method } = this.props;
    let loo_data = null;
    if(loo_chances == "HIGH_PROB"){
      loo_data = this.props.user.loo_indicator_tooltip_content_high_prob;
    }else if(loo_chances == "MEDIUM_PROB"){
      loo_data = this.props.user.loo_indicator_tooltip_content_medium_prob;
    }else if(loo_chances == "LOW_PROB"){
      loo_data = this.props.user.loo_indicator_tooltip_content_low_prob;
    } else {
      loo_data = this.props.user.loo_indicator_tooltip_content_no_prob;
    }
    if(admissions_method.loo_contents.length > 0){
      admissions_method.loo_contents.forEach(function(obj){
        if(obj.loo_prob == loo_chances){
          loo_data = obj.content
        }
      })
    }
    return loo_data;
  }

  handleLooAnalyticsMouseEnter = () => {
    const { program, school, loggedIn } = this.props;
    const { code, name } = program;
    let dataDictionary = {
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: 'looTooltip',
      dataDictionary: dataDictionary,
    });
  }

  handleLooProgramFavoriteAction = (is_favorited) => {
    const { program, school, loggedIn } = this.props;
    const { code, name } = program;
    let dataDictionary = {
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: is_favorited ? 'programFavorited' : 'programUnfavorited',
      dataDictionary: dataDictionary,
    });
  }

  handleLooProgramAddToApplicationAction = (is_added) => {
    const { program, school, loggedIn } = this.props;
    const { code, name } = program;
    let dataDictionary = {
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: is_added ? 'programAdded' : 'programRemoved',
      dataDictionary: dataDictionary,
    });
  }

  looTooltipBody = () => {
    const { intl, title, loo_chances } = this.props;
    let loo_data = this.looTooltipContent();
    return (
      <div className={style.tip} data-coachmark="search-step-7">
        <Tooltip
          {...this.props}
          icon={<LooIcon loo_chances={loo_chances} height='29.122' width='34.306'/>}
          ariaLabel={customisedIntlFormatMessage(intl, messages.schoolProgramEligibleInfo, {
            programTitle: title,
            schoolName: this.props.directory_school_name,
          })}
          keepTooltipOpen={true}
          onMouseEnter={this.handleLooAnalyticsMouseEnter}
        >
          <div> <LooIcon loo_chances={loo_chances} height='59.244' width='68.612' /> </div>
          <div>
            <p className={style.looText} dangerouslySetInnerHTML={{ __html: loo_data }} />
          </div>
          {this.renderLooPriorityGroup()}
        </Tooltip>
      </div>
    );
  };

  handleTooltipMouseLeave = () =>
    this.setState({
      ...this.state,
      showTooltip: false,
    });

  handleTooltipMouseEnter = () =>
    this.setState({
      ...this.state,
      showTooltip: true,
    });

  handleTooltipBlur = () => {
    const { showTooltip } = this.state;
    if (showTooltip) {
      this.toggleTooltip();
    }
  };

  joinWaitlistConfirm = (id, schoolId, isWaitlistJoinable, saved, savedProgramId) => {
    if (!this.props.user.applicationId || this.props.user.applicationId === '') {
      this.setState({
        ...this.state,
        showModal: true,
        modalContext: 'application',
      });
      return;
    }

    if (isWaitlistJoinable) {
      this.props.joinWaitlist(id, schoolId, isWaitlistJoinable);
    }

    if (!saved) {
      this.props.saveProgram(id, schoolId, saved, savedProgramId);
    }
    return true;
  }; 

  renderEligiblityTip = () => {
    const { eligible, user } = this.props;

    if (isEL({ user })) {
      return true;
    }

    if (user.isSR) {
      return true;
    }

    if (this.props.user.show_loo_tooltip) {
      return this.looTooltipBody()
    }

    if (eligible === false) {
      return this.ineligibleTooltipBody();
    }
    if (this.props.is_zoned_program) {
      return this.zonedProgramTooltipBody();
    } else if (this.props.is_current_school) {
      if (isK({ user }) || isPK({ user }) || is2K({ user }) || is3K({ user })) {
        return this.currentSchoolTooltipBodyK();
      }
      return this.currentSchoolTooltipBody();
    } else if (eligible) {
      if (isK({ user }) || isPK({ user }) || is2K({ user }) || is3K({ user })) {
        return this.eligibleKindergartenTooltipBody();
      }
      // hiding tooltip for MS Applications : MYS-916
      if (isMS({ user })) {
        return null;
      }
      return this.eligibleTooltipBody();
    }

    // sk: fn expects a return
    return true;
  };

  renderLooPriorityGroup = () => {
    const {directory_student_program, directory_priority_groups} = this.props;
    if (!directory_student_program.length) {
      return null;
    }

    const all = directory_priority_groups.filter(priority => priority.name);

    if (directory_student_program[0].priority_group) {
      const studentPriorityGroup = directory_student_program[0].priority_group;
      const forStudent = studentPriorityGroup.order;
      let studentPriorityGroupName = studentPriorityGroup.name;
      let studentPriorityGroupDescription = studentPriorityGroup.ge_priority_group_description;
      if (this.props.user.is_student_swd){
        studentPriorityGroupDescription = studentPriorityGroup.swd_priority_group_description
      }
      // const { all, forStudent, studentPriorityGroupDescription } = getPriorityGroups();

      const currentPriority = all.map(priority => {
        if (priority.order === forStudent) {
          return (
            <span key={`priority-${priority.id}`} className={style.activePriorityNumberToolTip}>
              {priority.order}
            </span>
          );
        }
        return (
          <span key={`priority-${priority.id}`} className={style.priorityNumberToolTip}>
            {priority.order}
          </span>
        );
      });
      return (
        <div className={style.statsBox}>
          <div className={style.statsBoxTitle}>
            <FormattedMessage {...messages.generalStringToolTipPriorityGroup} />
          </div>
          <div>{currentPriority}</div>
          <div>{studentPriorityGroupName}</div>
          <div>{studentPriorityGroupDescription}</div>
        </div>
      );
    }
    return null;
  };

  renderPriorityGroup = () => {
    const { getPriorityGroups, admissionMethod } = this.props;
    const isLimitedUnscreened = admissionMethod.name === 'Limited Unscreened';
    const { all, forStudent, studentPriorityGroupDescription } = getPriorityGroups();

    if (!all || all.filter(priority => priority.name).length === 0) {
      return null;
    }

    const currentPriority = all.map(priority => {
      if (priority.order === forStudent) {
        return (
          <span key={`priority-${priority.id}`} className={style.activePriorityNumberToolTip}>
            {priority.order}
          </span>
        );
      }
      return (
        <span key={`priority-${priority.id}`} className={style.priorityNumberToolTip}>
          {priority.order}
        </span>
      );
    });
    return (
      <div className={style.statsBox}>
        <div className={style.statsBoxTitle}>
          <FormattedMessage {...messages.generalStringToolTipPriorityGroup} />
        </div>
        {!isLimitedUnscreened ? (
          <Fragment>
            <div>{currentPriority}</div>
            {studentPriorityGroupDescription && studentPriorityGroupDescription.replace('Then to ', '')}
          </Fragment>
        ) : (
          <div className={style.limitedUnscreenedMessage}>
            <FormattedMessage {...messages.schoolProgramLimitedUnscreenedTooltip} />
          </div>
        )}
      </div>
    );
  };

  renderApplication = () => {
    const {
      scheduling,
      id,
      schoolId,
      savedApplication,
      savedApplicationId,
      testing_not_registered,
      saved,
      savedProgramId,
      intl,
      eligible,
      user,
      program,
    } = this.props;

    if (!this.shouldRenderApplication() || !eligible) {
      return null;
    }

    const canSubmitApplication = user.can_submit;

    // render remove application button if the application is saved
    if (savedApplication && canSubmitApplication) {
      return (
        <Button
          onClick={() =>
            this.saveApplicationFunc(id, schoolId, savedApplication, savedApplicationId, saved, savedProgramId)
          }
          aria-label={customisedIntlFormatMessage(intl, messages.generalStringRemoveFromApplication)}
          label={customisedIntlFormatMessage(intl, messages.generalStringRemoveFromApplication)}
          iconLeft="list-undo"
          iconColor="#4ee4b3"
        />
      );
    }

    const needsScheduling = !applySchedulingOk(scheduling) && !user.isRound2;
    const applicationLimitReached = user.maxPrograms !== null ? user.studentApplications.results.length >= user.maxPrograms : false;
    const isSHSOnHSApplication = program.is_shs && !user.isSHS;
    let addToApplicationDisabled = true;
    if (!user.isSR){
      addToApplicationDisabled =
        needsScheduling || applicationLimitReached || isSHSOnHSApplication || testing_not_registered;
    }
    else{
      addToApplicationDisabled =
        needsScheduling || isSHSOnHSApplication || testing_not_registered;
    }

    let tooltipMessage;
    if (isSHSOnHSApplication) {
      tooltipMessage = messages.generalStringProgramHasDifferentAdmissionProcess;
    } else if (needsScheduling) {
      tooltipMessage = messages.generalStringProgramNeedsAssessment;
    } else if (testing_not_registered) {
      tooltipMessage = messages.generalStringAddMTD21ToApplicationTooltip;
    } else {
      tooltipMessage = messages.generalStringAddToApplicationTooltip;
    }
    // render normal button, disabled if scheduling step is needed first
    return (
      <div>
        <div className={style.saveApplicationButtonWrapper}>
          {canSubmitApplication && (
            <Fragment>
              <Button
                onClick={() =>
                  this.saveApplicationFunc(id, schoolId, savedApplication, savedApplicationId, saved, savedProgramId)
                }
                aria-label={customisedIntlFormatMessage(intl, messages.generalStringAddToApplication)}
                label={customisedIntlFormatMessage(intl, messages.generalStringAddToApplication)}
                iconLeft="Plus"
                iconColor="#4ee4b3"
                disabled={addToApplicationDisabled}
              />
              <div className={style.saveApplicationButtonTooltipIconWrapper}>
                <Tooltip {...this.props} icon={<i className="icon-Question" />}>
                  {isSHSOnHSApplication ? (
                    <FormattedMessage {...tooltipMessage} values={{ admissionProcess: program.admission_process }} />
                  ) : (
                    <FormattedMessage {...tooltipMessage} />
                  )}
                </Tooltip>
              </div>
            </Fragment>
          )}
        </div>
        {applicationLimitReached && (
          <div>You already have {{maxPrograms}} programs in your application. Go to the Apply page and remove some to add</div>
        )}
      </div>
    );
  };

  handleRemoveFromWaitlists = (id, waitlistProgramId, joinedWaitlist, schoolId) => {
    // for user state:
    this.props.removeFromWaitlist(id, waitlistProgramId, joinedWaitlist, schoolId);
    // for schools state:
    this.props.removeFromWaitlistSchoolDirectory(id, waitlistProgramId, joinedWaitlist, schoolId);
  };

  renderWaitlist = () => {
    const {
      id,
      schoolId,
      joinedWaitlist,
      // on_submitted_application,
      saved,
      savedProgramId,
      intl,
      eligible,
      user,
      program,
      waitlistProgramId,
      canAddRemoveWaitlist,
      waitlist_offers,
    } = this.props;

    if (!this.shouldRenderApplication() || !eligible) {
      return null;
    }

    const canJoinWaitlist = user.can_submit;

    const canDisplayWaitlist = program.enable_waitlist_on_parent_portal;

    // check if an offer exists for this program
    const hasExistingOffer = !!(waitlist_offers && waitlist_offers.id && waitlistProgramId === waitlist_offers.id);

    // locked offer means the existing offer has a response of "AC" or "PE"
    // to prevent user from deleting the waitlist record
    const lockedOffer =
      hasExistingOffer &&
      (waitlist_offers.offer_response === 'AC' || waitlist_offers.offer_response === 'PE' || waitlist_offers.offer_response === 'OO'); 

    // determine whether to show the "Join Waitlist" button.
    // if there is an existing offer, we show the button only if the offer response is not AC or PE.
    // if there is no existing offer, we show it only if the user hasn't joined the waitlist.
    const isWaitlistJoinable =
      canDisplayWaitlist &&
      canJoinWaitlist &&
      canAddRemoveWaitlist &&
      !program.is_shs &&
      (hasExistingOffer ? !lockedOffer : !joinedWaitlist);

    const confirmButton = (
      <Button
        onClick={() => this.joinWaitlistConfirm(id, schoolId, isWaitlistJoinable, saved, savedProgramId)}
        aria-label={customisedIntlFormatMessage(intl, messages.generalStringAddWaitlist)}
        label={customisedIntlFormatMessage(intl, messages.generalStringAddWaitlist)}
        iconLeft="Plus"
        iconColor="#4ee4b3"
        disabled={!canJoinWaitlist || !canAddRemoveWaitlist}
      />
    );

    return (
      <div>
        <div className={style.saveApplicationButtonWrapper}>
        {isWaitlistJoinable && confirmButton}
        {!program.is_shs &&
        joinedWaitlist &&
        !hasExistingOffer && (
              <Fragment>
                <Button
                  onClick={() => this.handleRemoveFromWaitlists(id, waitlistProgramId, !joinedWaitlist, schoolId)}
                  customClass={style.removeWaitlistButton}
                  aria-label={customisedIntlFormatMessage(intl, messages.generalStringRemoveFromWaitlist)}
                  label={customisedIntlFormatMessage(intl, messages.generalStringRemoveFromWaitlist)}
                  iconLeft="Close"
                  iconColor="inherit"
                  secondary
                />
              </Fragment>
            )}
        </div>
      </div>
    );
  };

  render() {
    const {
      applyCard,
      emphasize,
      eligible,
      saved,
      selected,
      firstName,
      title,
      intl,
      id,
      schoolId,
      description,
      savedProgramId,
      savedApplication,
      singleProgramCard,
      scheduling,
      scheduleProgram,
      initScheduling,
      user,
      schoolName,
      removeNoMatchingTimeSlot,
      joinedWaitlist,
      testing_not_registered,
      admissionsOpen,
      waitlistOpen,
      resultsEnabled,
      isAffiliatedSRLocation,
      program,
      admissionProcess
    } = this.props;
    const { programOpen, showModal, height, showTooltip } = this.state;
    const isSchedule = scheduleProgram !== null;
    const starClass = [style.star];
    if (selected) {
      starClass.push(style.starSelected);
    }
    if (saved) {
      if (!isAffiliatedSRLocation) {
        starClass.push(style.starSaved);
      }
      else{
        starClass.push(style.starAffiliatedSaved);
      }
    }

    if (isSchedule) {
      starClass.push(style.starSchedule);
    }
    if (testing_not_registered) {
      starClass.push(style.starDisabled);
    }
    /* eslint-disable no-useless-computed-key */
    const starIconFill = saved ? '#4EE4b3' : '#FFF';
    const titleClass = [style.title];
    const titleLinkClasses = [style.titleLink];
    const titleAndTip = [style.titleAndTip];
    const rootClasses = [style.root];

    if (programOpen) {
      titleLinkClasses.push(style.titleLinkTitleIsOpen);
      titleClass.push(style.titleTitleIsOpen);
      rootClasses.push(style.rootIsOpen);
    }
    if (emphasize) {
      titleClass.push(style.titleEm);
    }
    const hasAppointment = programHasAppointment(scheduling) || programHasExpressionOfInterest(scheduling);
    // show schedule either if it's a single program card, or if it's an opened program card in the detail view
    const showSchedule = isSchedule && (singleProgramCard || programOpen >= 1);
    const canNotUnsaveProgram = savedApplication || hasAppointment || joinedWaitlist;
    const ariaPressedLabel = { active: true, value: saved };

    const schoolProgramUnsave = customisedIntlFormatMessage(intl, localMessages.schoolProgramUnsaveWithProgramSchoolDescription, {
      programTitle: title,
      schoolName,
    });

    const schoolProgramSave = customisedIntlFormatMessage(intl, localMessages.schoolProgramSaveWithProgramSchoolDescription, {
      programTitle: title,
      schoolName,
    });

    let userLoggedIn = false;
    if (user && user.guardianId) {
      userLoggedIn = true;
    }

    let applicationOpen = admissionsOpen;
    let waitlistsOpen = waitlistOpen;
    let resultEnabled = resultsEnabled;

    let canNotUnsaveProgramContent = null;
    if (canNotUnsaveProgram) {
      canNotUnsaveProgramContent = (
        <Tooltip
          {...this.props}
          icon={<MultiColoredStarIcon size={20} fill={starIconFill} />}
          click="true"
          ariaLabel={schoolProgramUnsave}
          isAriaPressed={ariaPressedLabel}
          simulateClick={true}
          onMouseLeave={this.handleTooltipMouseLeave}
          onMouseEnter={this.handleTooltipMouseEnter}
        >
          {savedApplication && (
            <div className={style.unsaveProgramToolTip}>
              <h6>
                <FormattedMessage {...localMessages.schoolProgramIsAddedToApplicationTitle} />
              </h6>
              <FormattedMessage {...localMessages.schoolProgramIsAddedToApplication} />
            </div>
          )}
          {hasAppointment && (
            <div className={style.unsaveProgramToolTip}>
              <h6>
                <FormattedMessage {...localMessages.schoolProgramHasScheduledAppointmentTitle} />
              </h6>
              <FormattedMessage {...localMessages.schoolProgramHasScheduledAppointment} />
            </div>
          )}
          {joinedWaitlist && (
            <div className={style.unsaveProgramToolTip}>
              <h6>
                <FormattedMessage {...localMessages.schoolProgramJoinedWaitlistTitle} />
              </h6>
              <FormattedMessage {...localMessages.schoolProgramJoinedWaitlist} />
            </div>
          )}
        </Tooltip>
      );
    }
    const isSRProcess = isSR({ user }) || this.admissionProcess === 'SR' || admissionProcess === 'SR';
    let headerTitle = title;
    if (isSRProcess && program.code)
    {
      headerTitle = headerTitle + ' - ' + program.code
    }

    return (
      <div className={classNames(...rootClasses)}>
        <button
          className={classNames(...starClass)}
          disabled={this.props.testing_not_registered}
          data-star="true"
          data-coachmark="search-step-6"
          onClick={() => this.saveProgramFunc(id, schoolId, saved, savedProgramId)}
          aria-label={saved ? schoolProgramUnsave : schoolProgramSave}
          aria-pressed={saved}
          onBlur={this.handleTooltipBlur}
        >
          <div className={style.saveProgramContainer}>
            {!canNotUnsaveProgram && (
              <div className={style.starButton}>
                <MultiColoredStarIcon size={20} fill={starIconFill} />
              </div>
            )}
            {canNotUnsaveProgramContent}
          </div>
        </button>
        <div className={style.programBody}>
          <div className={titleAndTip}>
            <div className={classNames(...titleClass)}>
              <span
                className={classNames(...titleLinkClasses)}
                role="button"
                tabIndex="0"
                onKeyDown={event => this.handleProgramClick(event)}
                onClick={event => this.handleProgramClick(event)}
                aria-expanded={this.state.programOpen >= 1}
              >
                {headerTitle}
              </span>
              {!applyCard &&
                savedApplication && (
                  <span className={style.appliedTipContainer}>
                    <AlreadyAppliedIcon
                      size="22"
                      fill="#024CBC"
                      ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramAddedToYourApplication)}
                    />
                  </span>
                )}
              {!applyCard &&
                joinedWaitlist && (
                  <span className={style.appliedTipContainer}>
                    <JoinedWaitlistIcon
                      size="22"
                      fill="#024CBC"
                      ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramAddedToYourApplication)}
                    />
                  </span>
                )}
              {this.renderEligiblityTip()}
            </div>
            {programOpen >= 1 && (
              <div>
                {!isSRProcess && (<p>{description}</p>)}
                {!isWaitlist({ user }) ? <div>{this.renderApplication()}</div> : <div>{this.renderWaitlist()}</div>}
              </div>
            )}
          </div>
          <AnimateHeight duration={300} height={height} style={{ width: '100%' }}>
            {this.getSchoolProgramInfo()}
          </AnimateHeight>
          {showSchedule && (
            <ScheduleInfo
              program={scheduleProgram}
              initScheduling={initScheduling}
              removeNoMatchingTimeSlot={removeNoMatchingTimeSlot}
              isDetailView={!!programOpen}
              eligible={eligible}
              studentFirstName={firstName}
              isSHS={this.props.user.isSHS}
            />
          )}
        </div>
        {(userLoggedIn && applicationOpen) ? (
          <Lightbox
            open={this.open}
            close={this.close}
            showModal={showModal}
            ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramLoggedInModalTitle)}
          >
            <h3>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserTitle} />
            </h3>
            <p>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserDescription} />
            </p>
            <p>
              <ButtonAction
                aria-label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                icon="Caret-Right"
                onClick={this.dashboard}
                large
              />
            </p>
          </Lightbox>
        ) : (userLoggedIn && waitlistsOpen) ? (
          <Lightbox
            open={this.open}
            close={this.close}
            showModal={showModal}
            ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramLoggedInModalTitle)}
          >
            <h3>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserTitle} />
            </h3>
            <p>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserWaitlistNoResultDescription} />
            </p>
            <p>
              <ButtonAction
                aria-label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                icon="Caret-Right"
                onClick={this.dashboard}
                large
              />
            </p>
          </Lightbox>
        ) : (userLoggedIn && resultEnabled) ? (
          <Lightbox
            open={this.open}
            close={this.close}
            showModal={showModal}
            ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramLoggedInModalTitle)}
          >
            <h3>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserTitle} />
            </h3>
            <p>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserWaitlistResultDescription} />
            </p>
            <p>
              <ButtonAction
                aria-label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                icon="Caret-Right"
                onClick={this.dashboard}
                large
              />
            </p>
          </Lightbox>
        ) : (userLoggedIn && !applicationOpen && !waitlistsOpen && !resultEnabled) ? (
          <Lightbox
            open={this.open}
            close={this.close}
            showModal={showModal}
            ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramLoggedInModalTitle)}
          >
            <h3>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserTitle} />
            </h3>
            <p>
              <FormattedMessage {...localMessages.schoolProgramSaveLoggedInUserClosedProgramDescription} />
            </p>
            <p>
              <ButtonAction
                aria-label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                label={customisedIntlFormatMessage(intl, messages.generalStringGoToDashboard)}
                icon="Caret-Right"
                onClick={this.dashboard}
                large
              />
            </p>
          </Lightbox>
        ) : (
          <Lightbox
            open={this.open}
            close={this.close}
            showModal={showModal}
            ariaLabel={customisedIntlFormatMessage(intl, localMessages.schoolProgramSaveUnloggedInUserTitle)}
          >
            <h3>
              <FormattedMessage {...localMessages.schoolProgramSaveUnloggedInUserTitle} />
            </h3>
            <p>
              <FormattedMessage {...localMessages.schoolProgramSaveUnloggedInUserDescription} />
            </p>
            <ButtonAction
              aria-label={customisedIntlFormatMessage(intl, messages.generalStringSignUp)}
              label={customisedIntlFormatMessage(intl, messages.generalStringSignUp)}
              icon="Caret-Right"
              onClick={this.signUp}
              large
            />
            <p className={style.modalLogIn}>
              <FormattedMessage {...messages.generalStringExistingAccount} />
              &nbsp;
              <a href={`/${intl.locale}/account/log-in/`}>
                <FormattedMessage {...messages.generalStringLogInHere} />
              </a>
            </p>
          </Lightbox>
        )}
      </div>
    );
  }
}

const mapState = ({ user, schools: { canAddRemoveWaitlist } }) => ({ user, canAddRemoveWaitlist });
const mapDispatch = {
  saveProgram,
  saveApplication,
  showPopupContent,
  joinWaitlist,
  removeFromWaitlist,
  removeFromWaitlistSchoolDirectory,
};

export default withRtl(style)(injectIntl(connect(mapState, mapDispatch)(withStyles(style)(SchoolProgram))));
